import { createStyles, makeStyles } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { useDocumentPermissions, useViewerState } from "../../hooks/index.js";
const useStyles = makeStyles(() => createStyles({
  root: {
    position: 'absolute',
    resize: _ref => {
      let {
        permissions,
        rotationDegree
      } = _ref;
      return `${permissions.canEdit && rotationDegree === 0 ? 'both' : 'none'}`;
    },
    overflow: 'hidden',
    backgroundColor: 'blanchedalmond',
    lineHeight: _ref2 => {
      let {
        shape,
        zoomRatio
      } = _ref2;
      return `${shape.lineHeight * zoomRatio}px`;
    },
    fontWeight: _ref3 => {
      let {
        shape
      } = _ref3;
      return shape.fontBold;
    },
    color: _ref4 => {
      let {
        shape
      } = _ref4;
      return shape.fontColor;
    },
    fontFamily: _ref5 => {
      let {
        shape
      } = _ref5;
      return shape.fontFamily;
    },
    fontSize: _ref6 => {
      let {
        shape,
        zoomRatio
      } = _ref6;
      return `${shape.fontSize * zoomRatio}px`;
    },
    fontStyle: _ref7 => {
      let {
        shape
      } = _ref7;
      return shape.fontItalic ? 'italic' : 'normal';
    },
    boxShadow: _ref8 => {
      let {
        zoomRatio
      } = _ref8;
      return `${5 * zoomRatio}px ${5 * zoomRatio}px ${15 * zoomRatio}px rgba(0,0,0,.3)`;
    },
    padding: _ref9 => {
      let {
        zoomRatio
      } = _ref9;
      return `${10 * zoomRatio}pt`;
    },
    boxSizing: 'border-box'
  }
}));
/**
 * Return a styled annotation wrapper component
 * @param permissions The permissions of the user
 * @param shape The arguments of the annotation
 * @param zoomRatio The ratio of the origina and virtual page
 * @param dimensions The dimensions of the annotation
 * @param onDragStart Function triggered on drag event
 * @param onResized Function triggered on resize event
 * @param onRightClick Function triggered on right click
 * @param renderChildren Function what returns the wrapped components
 * @returns styled annotation wrapper component
 */

export const AnnotationWrapper = props => {
  const permissions = useDocumentPermissions();
  const classes = useStyles({ ...props,
    permissions
  });
  const annotationElement = useRef(null);
  const viewerState = useViewerState();
  const {
    updateState
  } = viewerState;
  useEffect(() => {
    const handleGlobalMouseUp = () => {
      if (viewerState.currentlyResizedElementId === props.shape.guid) {
        var _annotationElement$cu;

        updateState({
          currentlyResizedElementId: undefined
        });
        const newSize = props.onResized((_annotationElement$cu = annotationElement.current) === null || _annotationElement$cu === void 0 ? void 0 : _annotationElement$cu.getClientRects()[0]);

        if (annotationElement.current && newSize) {
          annotationElement.current.style.width = `${newSize.w * props.zoomRatio}px`;
          annotationElement.current.style.height = `${newSize.h * props.zoomRatio}px`;
        }
      }
    };

    document.addEventListener('mouseup', handleGlobalMouseUp);
    return () => {
      document.removeEventListener('mouseup', handleGlobalMouseUp);
    };
  }, [props, updateState, viewerState.currentlyResizedElementId]);
  useEffect(() => {
    const mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'style') {
          updateState({
            currentlyResizedElementId: props.shape.guid
          });
        }
      });
    });
    annotationElement.current && mutationObserver.observe(annotationElement.current, {
      attributes: true
    });
    return () => mutationObserver.disconnect();
  }, [props.shape.guid, updateState]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    tabIndex: 0,
    draggable: permissions.canEdit,
    onDragStart: props.onDragStart,
    onContextMenu: props.onRightClick,
    style: {
      top: props.dimensions.top,
      left: props.dimensions.left,
      width: `${props.dimensions.width}px`,
      height: `${props.dimensions.height}px`
    },
    ref: annotationElement
  }, props.children);
};
//# sourceMappingURL=annotation-wrapper.js.map